
// Generated by dayjs-nuxt-module
import dayjs from 'dayjs'
import 'dayjs/locale/vi'
import 'dayjs/locale/en'
import relativeTime from 'dayjs/plugin/relativeTime'
import updateLocale from 'dayjs/plugin/updateLocale'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(relativeTime)
dayjs.extend(updateLocale)
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.extend(updateLocale)
dayjs.locale('vi')
dayjs.locale('en')
dayjs.tz.setDefault('Asia/Ho_Chi_Minh')


dayjs.updateLocale("en")

export default dayjs
